let inMemoryToken = '';

function getToken() {
  return inMemoryToken || '';
}

function resolveApiBaseUrl() {
  const envBase = typeof process !== 'undefined' ? (process.env.REACT_APP_ADMIN_API_BASE_URL || process.env.REACT_APP_API_BASE_URL) : undefined;
  if (envBase) return String(envBase).replace(/\/$/, '');

  try {
    const host = window && window.location && window.location.hostname ? String(window.location.hostname) : '';
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:4000';
  } catch (_) {
    // ignore
  }

  return 'https://api.aryahomeohall.com';
}

function setToken(token) {
  inMemoryToken = String(token || '');
}

function clearToken() {
  inMemoryToken = '';
}

async function apiRefresh() {
  const json = await apiPost('/auth/refresh', undefined, { skipRefresh: true });
  const token = json && json.data && json.data.token ? String(json.data.token) : '';
  if (token) setToken(token);
  return json;
}

async function apiLogout() {
  clearToken();
  return apiPost('/auth/logout', undefined, { skipRefresh: true });
}

async function apiMe() {
  const data = await apiGet('/auth/me');
  return data;
}

async function apiRequest(path, { method = 'GET', body, headers, skipRefresh } = {}) {
  const base = resolveApiBaseUrl();
  const url = `${base}/api${path.startsWith('/') ? '' : '/'}${path}`;

  const token = getToken();

  const isFormData =
    typeof FormData !== 'undefined' &&
    typeof body !== 'undefined' &&
    body !== null &&
    body instanceof FormData;

  const res = await fetch(url, {
    method,
    credentials: 'include',
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(headers || {}),
    },
    body: typeof body === 'undefined' ? undefined : isFormData ? body : JSON.stringify(body),
  });

  let json;
  try {
    json = await res.json();
  } catch (_) {
    json = null;
  }

  if ((!res.ok || !json || json.success !== true) && res.status === 401 && !skipRefresh && token) {
    try {
      await apiRefresh();
      return apiRequest(path, { method, body, headers, skipRefresh: true });
    } catch (_) {
      clearToken();
    }
  }

  if (!res.ok || !json || json.success !== true) {
    if (res.status === 401) {
      clearToken();
    }
    const msg = json && json.message ? json.message : `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = json;
    throw err;
  }

  return json;
}

async function apiGet(path, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'GET' });
  return json.data;
}

async function apiPost(path, body, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'POST', body });
  return json;
}

async function apiPut(path, body, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'PUT', body });
  return json;
}

async function apiPatch(path, body, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'PATCH', body });
  return json;
}

async function apiDelete(path, options) {
  const json = await apiRequest(path, { ...(options || {}), method: 'DELETE' });
  return json;
}

async function apiLogin(email, password) {
  const normalize = (value) => {
    const raw = String(value || '').trim();
    try {
      return raw.normalize('NFKC');
    } catch (_) {
      return raw;
    }
  };

  const json = await apiPost('/auth/login', { email: normalize(email), password: normalize(password) }, { skipRefresh: true });
  const token = json && json.data && json.data.token ? String(json.data.token) : '';
  if (token) setToken(token);
  return json;
}

export { apiGet, apiPost, apiPut, apiPatch, apiDelete, apiLogin, apiRefresh, apiLogout, apiMe, setToken, clearToken, getToken };
